import { ActionIcon, Badge, Box, Group, Stack, Text } from '@mantine/core';
import { faThumbsDown, faThumbsUp } from '@fortawesome/pro-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SentimentCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const sentimentEval = rowData.evaluations?.sentiment;
    const sentimentValue = sentimentEval?.compound;

    const badgeColor = (value) => {
        if (!value) {
            return 'gray';
        }
        return value > 0 ? 'teal.6' : 'red';
    };
    return (
        <Badge
            size={'xs'}
            color={badgeColor(sentimentValue)}>
            {sentimentValue ?? '---'}
        </Badge>
    );
};

const IdColumn = () => ({
    accessorKey: 'sentiment',
    header: 'Sentiment',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <SentimentCell cell={cell} />,
});
export default IdColumn;
